import { all, takeLatest } from 'lib/redux';
import { DELETE_ACCOUNT } from 'constants/ActionTypes';
import deleteAccountSaga from './AccountsDeletion.saga';

export default function* watchers() {
  yield all([
    takeLatest(DELETE_ACCOUNT, deleteAccountSaga),
  ]);
}
